var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"statusModule":"rdsAccount","base-info":_vm.baseInfo,"data":_vm.data,"on-manager":_vm.onManager,"is-edit-name":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }